import { t, Trans } from "@lingui/macro";
import { useAtomValue } from "jotai";

import { sessionCurrentClubAtom } from "@/features/Session";
import { Button } from "@whoosh/design-system/src/components/controls";
import { PersonFilledIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type NavigationMenuJoinCardProps = {
  onSignIn: () => void;
};

export const NavigationMenuJoinCard = ({
  onSignIn,
}: NavigationMenuJoinCardProps) => {
  const club = useAtomValue(sessionCurrentClubAtom);
  const clubName = club?.name ?? t`the club`;

  return (
    <VStack
      backgroundColor="surface-main-primary-subtlest"
      borderRadius="4"
      padding={4}
      alignItems="center"
      gap={4}
    >
      <Box
        width={48}
        height={48}
        borderRadius="6"
        backgroundColor="surface-primary"
        alignItems="center"
        justifyContent="center"
        style={{
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
        }}
      >
        <PersonFilledIcon color="text-primary" width={16} height={16} />
      </Box>
      <Text variant="mainBaseSemiBold" color="text-primary" textAlign="center">
        <Trans>Join {clubName} and never miss a tee time again!</Trans>
      </Text>
      <Button
        variant="white"
        size="tiny"
        width="100%"
        onPress={onSignIn}
        accessibilityLabel={t`Sign In or Sign Up`}
      >
        <Trans>Sign In or Sign Up</Trans>
      </Button>
    </VStack>
  );
};
